import React, { Component } from "react";
import { GlobalContext } from "../../utils/globalprovider.js";
class DialogUpload extends React.Component
{
    static contextType = GlobalContext;
    constructor(props)
    {
        super(props);
        this.dropfile =  null;

        this.state = {message:"", errormsg:"", image: this.props.image};
        this.handleMouseDown = this.handleMouseDown.bind(this);

        this.msgsize = 13;
        if (this.props.width < 150) this.msgsize = 9;


        this.setNewBase64Data = this.setNewBase64Data.bind(this);
    }

    


componentDidMount()
{




    if (this.props.disabled) return;

    this.fileInput = document.createElement('input');
    this.fileInput.type = 'file';
    this.fileInput.style.display = 'none';

    this.fileInput.addEventListener('change', () => {
        if (this.fileInput.files.length > 0) {
            if (this.fileInput.files.length > 0) 
                {
                    console.log('Fichier déposé:', this.fileInput.files[0]);
                    var dropfile = this.fileInput.files[0];
                    dropZone.style.borderColor = '#ccc'
                    const extension = this.getFileExtension (dropfile)
            
                    var errormsg="";
                    if ((this.props.validFiles.length != 0) && ((extension ==="") || (!this.props.validFiles.includes(extension)) ))
                        errormsg = this.context.language=="fr"?"Type de fichier non valide.":"Invalid format file.";
                    else 
                    {
                        this.dropfile = dropfile;
                
                
                        if (this.props.mode == "image")
                        {
                            
                            const reader = new FileReader();
                            // Convert the file to a Base64 string
                            reader.onload = (e) => {
                                
                                var base64String = e.target.result;
                                this.setNewBase64Data (base64String)
                                // Display the Base64 string in the textarea
                                
                            };        
                            reader.readAsDataURL(this.dropfile);
                        }
                
                      }
                                
                  this.setState({errormsg:errormsg});
          
                  if (errormsg === "") this.props.onChange();
          
              }
            }
      });    

    var ltype= this.context.language=="fr"?"vidéo":"video";
    if (this.props.mode == "image")
        ltype= this.context.language=="fr"?"image":"image";

    var message = this.context.language=="fr"?"Glissez et déposez un fichier "+ltype+" ici ou cliquez pour sélectionner un fichier.":"Drag and drop a "+ltype+" file here or click to select a files";
    var errormsg = "";

    this.setState({message:message, errormsg:errormsg});



    const dropZone = document.getElementById('dropZoneUpload');


    // Empêche le comportement par défaut pour le drag-and-drop
    ['mousedown','dragenter', 'dragover', 'dragleave', 'drop'].forEach(eventName => {
      dropZone.addEventListener(eventName, e => e.preventDefault());
    });    

    // Ajoute les styles au survol
    ['dragenter', 'dragover'].forEach(eventName => {
    dropZone.addEventListener(eventName, () => dropZone.style.borderColor = 'green');
        });

 // Gestion du fichier
    dropZone.addEventListener('drop', e => {
    const files = e.dataTransfer.files; // Récupère les fichiers
    if (files.length > 0) {
      console.log('Fichier déposé:', files[0]);
      var dropfile = files[0];
      dropZone.style.borderColor = '#ccc'
      const extension = this.getFileExtension (dropfile)

      var errormsg="";
      if ((this.props.validFiles.length != 0) && ((extension ==="") || (!this.props.validFiles.includes(extension)) ))
        errormsg = this.context.language=="fr"?"Type de fichier non valide.":"Invalid format file.";
      else
      {
        this.dropfile = dropfile;

        console.log("start read file mode=", this.props.mode)

        if (this.props.mode == "image")
        {
            
            const reader = new FileReader();
            // Convert the file to a Base64 string
            reader.onload = (e) => {
                
                var base64String = e.target.result;
                this.setNewBase64Data (base64String)
                // Display the Base64 string in the textarea
                
            };        
            reader.readAsDataURL(this.dropfile);
        }

      }

     
        this.setState({errormsg:errormsg});

        if (errormsg === "") this.props.onChange();

    }
  });


}


    setNewBase64Data (base64String)
    {
        this.setState({image:base64String});
    }

    handleMouseDown ()
    {
        if (this.props.disabled) return;
        this.fileInput.click();
    }
    getFileExtension(file)
    {
        const filename = file.name; // Get the file name
        const index = filename.indexOf(".");
        if (index === -1) return "";
  
        const fileExtension = filename.split(".").pop().toLowerCase(); // Extract the file extension
        return fileExtension;
  
    }


    componentDidUpdate()
    {
        
    }

    getValue()
    {
        if (this.props.mode == "image") return this.state.image;
        return this.dropfile;
    }

    render()
    {

        var invit = (
            <>
            <span style={{color:"red", fontSize:this.msgsize}}>{this.state.errormsg}</span><br/>
            <span style={{fontSize:this.msgsize}}>{this.state.message}</span>
            </>
        );
        if ((this.props.mode == "image") && (this.state.image != ""))
        {
            invit = (
                <img src={this.state.image} height="100%"/>
            )
        }

        var style = {width:this.props.width};
        if (this.props.disabled) style.borderWidth="0"

        return (<>
            <div onClick={this.handleMouseDown} 
                className = "dialog-upload-zone" 
                id="dropZoneUpload" style={style}>
                
                {invit}
            </div>
            
        </>);
    }

}
DialogUpload.defaultProps = 
{
    width: 200,
    validFiles: [],
    mode: "upload",
    image: "",
    disabled:false,
}

export default DialogUpload